import React from 'react';
import {Card} from 'semantic-ui-react';
import {EmpyDataIcon} from '../../commons/icons/empyDataIcon';
import './styles.scss';

export const EmptyDataCard = () => {
  return (
    <Card raised fluid className='floating-report-empty-data'>
      <EmpyDataIcon />
      <p>No se ha encontrado información.</p>
    </Card>
  );
};
